import "./DepartmentsComponent.scss";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import ENV from "../../../constants/ENV";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import useSystemLockUpdateLabOs from "../../../shared/hooks/useSystemLockUpdateLabOs";

interface DepartmentsComponentProps {

}

const DepartmentsComponent = (props: DepartmentsComponentProps) => {
    useSystemLockUpdateLabOs();
    const dispatch = useDispatch();

    const token = useSelector((state: any) => state.account.token);

    let LabDepartmentsUrl = `${ENV.LAB_OS_URL}?module=departments&token=${token}`;

    useEffect(() => {
        dispatch(setCurrentNavParams("Lab OS", "LabOS"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);


    const {currentUser} = useSelector((state: any) => state.account);
    const {selectedLab} = useSelector((state: any) => state.selectedLab);
    if(currentUser?.roleObj?.code !== "labAdmin" && selectedLab){
        LabDepartmentsUrl = `${ENV.LAB_OS_URL}?module=departments&token=${token}&labId=${selectedLab}`
    }

    return (
        <div className={'departments-component  lab-os-component'}>
            <iframe
                src={LabDepartmentsUrl}
                // src={`http://192.168.0.7:3005?token=${token}`}
                className={'labOs-iframe '}
                width="100%"
                height="100%"
                title={'LabOs'}
                loading={'eager'}
            />
        </div>
    );

};

export default DepartmentsComponent;
